module.exports = __webpack_public_path__ + "img/[篮球备份].57577363.svg";